// Opaque keys to ensure that permission tokens cannot be faked. This file is
// not publicly exposed.

export const SELF: unique symbol = Symbol('self');
export const VERIFIED: unique symbol = Symbol('verified');
